<template>
  <section class="gf-list-grid-controller">
    <div class="gf-list-grid-controller__group btn-group btn-group-sm">
      <button
        class="btn btn-sm"
        :class="{ active: gridState === 'list' }"
        type="button"
        @click="onChangeToListClick"
      >
        <i class="gf-icon gf-icon-toggle"></i>
      </button>
      <button
        class="btn btn-sm"
        :class="{ active: gridState === 'columns' }"
        type="button"
        @click="onChangeToColumnsClick"
      >
        <i class="gf-icon gf-icon-grip"></i>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GfListGridController',
  data() {
    return {
      // String 'list' || 'columns'
      gridState: null
    };
  },
  mounted() {
    this.getCurrentGridState();
  },
  methods: {
    getCurrentGridState() {
      const localStorageState = localStorage.getItem('projectListViewToggle');
      if (!localStorageState) {
        this.gridState = 'columns';
        this.updateLocalStorage('columns');
      } else {
        this.gridState = localStorageState;
        this.emitData();
      }
    },
    onChangeToListClick() {
      this.gridState = 'list';
      this.updateLocalStorage('list');
    },
    onChangeToColumnsClick() {
      this.gridState = 'columns';
      this.updateLocalStorage('columns');
    },
    updateLocalStorage(value) {
      this.emitData();
      localStorage.setItem('projectListViewToggle', value);
    },
    emitData() {
      this.$emit('update', this.gridState);
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-list-grid-controller';

#{$this} {
  #{$this}__group {
    & > button {
      background-color: var(--light);
      border: 1px solid var(--border-color);

      &:focus {
        box-shadow: none;
      }

      &.active {
        background-color: var(--border-color);
      }
    }
  }
}
</style>
